import React from 'react';
import { RenderBlocks } from '@plone/volto/components';

export const View = (props) => {
  const { data } = props;
  const metadata = props.metadata || props.properties;
  const CustomTag = `${data.as || 'div'}`;
  const customId = data?.title
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z-\s]/gi, '')
    ?.trim()
    ?.replace(/\s+/gi, '-');
  return (
    <CustomTag id={customId} className={data.custom_classes}>
      <RenderBlocks {...props} metadata={metadata} content={data?.data || {}} />
    </CustomTag>
  );
};
